import React from 'react';
import PropTypes from 'prop-types';
import isServer from '../../../../helpers/isServer';
import { getDocument } from '../../../../helpers/globals';

// tests for react components do not currently exist
// istanbul ignore next
const DragSwipe = ({
  id,
  children,
  includeMouseEvents,
  onSwipe,
  onDragStart,
  onDrag,
  onDragEnd,
  onStartAction,
  onMoveAction,
  onEndAction,
}) => {
  const onMoveHandler = (event) => {
    const { type, eventData } = onMoveAction({ id, event });

    if (type === 'drag-start' && onDragStart) {
      onDragStart(eventData);
    } else if (type === 'drag' && onDrag) {
      onDrag(eventData);
    }
  };

  const onEndHandler = () => {
    const { type, eventData } = onEndAction({ id });

    if (type === 'swipe' && onSwipe) {
      onSwipe(eventData);
    } else if (type === 'drag-end' && onDragEnd) {
      onDragEnd(eventData);
    }

    if (!isServer && includeMouseEvents) {
      getDocument().removeEventListener('mousemove', onMoveHandler);
      getDocument().removeEventListener('mouseup', onEndHandler);
    }
  };

  const onStartHandler = (event) => {
    onStartAction({ id, event, startTimestamp: new Date() });

    if (!isServer && includeMouseEvents) {
      getDocument().addEventListener('mousemove', onMoveHandler);
      getDocument().addEventListener('mouseup', onEndHandler);
    }
  };

  return (
    // There isn't always a role to apply. The role attribute should be
    // added in the html within the component that uses this util.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      onTouchStart={onStartHandler}
      onTouchMove={onMoveHandler}
      onTouchEnd={onEndHandler}
      onMouseDown={includeMouseEvents ? onStartHandler : null}
    >
      { children }
    </div>
  );
};

DragSwipe.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onDragStart: PropTypes.func,
  onDrag: PropTypes.func,
  onDragEnd: PropTypes.func,
  onSwipe: PropTypes.func,
  includeMouseEvents: PropTypes.bool,
  onStartAction: PropTypes.func.isRequired,
  onMoveAction: PropTypes.func.isRequired,
  onEndAction: PropTypes.func.isRequired,
};

export default DragSwipe;
